<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="75%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div :class="`col-6 col-sm-4 col-lg-4`">
            <label>
              {{ $t('labor.daily_hours_per_worker') }}
            </label>
            <br />
            <fg-input
              class="shadow-sm"
              type="number"
              min="1"
              max="14"
              step=".01"
              v-model="model.daily_hours"
              v-validate="modelValidations.daily_hours"
              name="labor.daily_hours_per_worker"
              :error="getError('labor.daily_hours_per_worker', true)"
              placeholder="9.2"
            >
            </fg-input>
          </div>
          <div :class="`col-6 col-sm-4 col-lg-4`">
            <label>
              {{ $t('labor.weekly_overtime_hours_per_worker') }}
            </label>
            <br />
            <fg-input
              class="shadow-sm"
              type="number"
              min="1"
              max="30"
              step=".01"
              v-model="model.weekly_overtime_hours"
              v-validate="modelValidations.weekly_overtime_hours"
              name="labor.weekly_overtime_hours_per_worker"
              :error="getError('labor.weekly_overtime_hours_per_worker', true)"
              placeholder="64.4"
            >
            </fg-input>
          </div>
          <div :class="`col-6 col-sm-4 col-lg-4`">
            <label>
              {{ $t('labor.daily_minimum_wage') }}
            </label>
            <br />
            <fg-input
              class="shadow-sm"
              type="number"
              min="0"
              step="any"
              v-model="model.daily_minimum_wage"
              v-validate="modelValidations.daily_minimum_wage"
              name="labor.daily_minimum_wage"
              :error="getError('labor.daily_minimum_wage', true)"
              placeholder="$..."
            >
            </fg-input>
          </div>
          <div :class="`col-12`">
            <select-businesses-component
              ref="selectBusiness"
              :showLoading="true"
              :requiered="true"
              :initialData="businessesInitial"
              @onChange="updateSelectedBusinesses"
              @showHideLoading="showHideLoading"
            />
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-configuration',
  mixins: [MixinDialog, MixinForm, MixinLoading, MixinValidations],
  data() {
    return {
      disabledField: false,
      model: {
        daily_hours: null,
        weekly_overtime_hours: null,
        daily_minimum_wage: null,
        businesses_id: [],
        businesses_names: [],
      },
      businessesInitial: [],
      modelValidations: {
        daily_hours: {
          required: true,
          decimal: true,
          min_value: 1,
          max_value: 14,
        },
        weekly_overtime_hours: {
          required: true,
          decimal: true,
          min_value: 1,
          max_value: 30,
        },
        daily_minimum_wage: {
          min_value: 0,
        },
      },
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
